import request from '@/utils/request'

/**
 * 家长发送咨询消息
 */
export function sendConsultMessage(data) {
  return request.post('/api/guide/messages/send', data)
}

/**
 * 成长规划师回复咨询消息
 */
export function replyConsultMessage(messageId, replyContent) {
  return request.post(`/api/guide/messages/${messageId}/reply`, { replyContent })
}

/**
 * 成长规划师获取咨询消息列表
 */
export function getConsultMessages(page = 1, size = 10, status, sort) {
  const data = { page, size, status }
  if (sort) data.sort = sort
  return request.post('/api/guide/messages/list', data)
}

/**
 * 家长获取自己的咨询记录
 */
export function getMyConsultMessages() {
  return request.post('/api/guide/messages/my')
}

/**
 * 成长规划师获取未读消息数（用于右上角铃铛角标）
 */
export function getUnreadMessageCount() {
  return request.post('/api/guide/messages/unread-count')
}